module.exports = __webpack_public_path__ + "img/img-3-2mobile.7bddf449.webp";